import _ from "underscore";
import $ from "jquery";

import View from "backdraft-app/src/view";

import Window from "shared/window_location";
import Loading from "shared/loading";
import ExceptionHandling from "shared/logging/exception_handling";

import template from "./action_dropdown/template.jst";

class ActionDropdown extends View {
  initialize(options) {
    super.initialize(options);
    this.options = $.extend({}, this.defaultOptions, options, { items: this._normalizeItems(options.items) });

    this.options.dropdownMenuClassName = this._dropdownMenuClassName();
    this.className = `${this.className} ${this.options.className}`;

    // className has special behavior in Backbone Views, even before the initialize is run they have already set the classes onto the element
    // so updating this.className is too late here
    this.$el.attr('class', this.options.className);
  }

  _dropdownMenuClassName() {
    let dropdownMenuClassName = 'dropdown-menu';

    switch (this.options.align) {
    case 'left':
      break;
    case 'right':
      dropdownMenuClassName += ' dropdown-menu-right';
      break;
    default:
      ExceptionHandling.logError(`Unrecognized align options: ${this.options.align}`);
    }

    return dropdownMenuClassName;
  }

  itemClicked(e) {
    e.preventDefault();
    const target = $(e.target);
    const clickedItem = this.options.items.filter(item => item.role === 'item' && target.data('id') === item.id)[0];

    if (clickedItem && !clickedItem.disabled) {
      if (typeof clickedItem.action === "function") {
        clickedItem.action(e);
      } else if (clickedItem.href) {
        Loading.show();
        Window.navigateTo(clickedItem.href);
      }
    }
  }

  render() {
    const anyIcons = this.options.items.filter(item => item.icon).length > 0;
    this.$el.html(this.template(_.extend({}, this.options, { anyIcons, logError: (...args) => { ExceptionHandling.logError(...args); } })));
    this.$el.on("click", "[data-mount=dropdown-item]", this.itemClicked.bind(this));
    // specify to place tooltip left (and will fallback to right) to workaround Bootstrap bug when tooltip is in an
    // overflow container and there is not room to render it optimally, it flickers around when the mouse gets in the way
    this.$('[data-toggle=tooltip]').tooltip({ placement: 'left' });

    return this;
  }

  _normalizeItems(items) {
    return _.map(
      _.filter(items, item => {
        const isPresent = _.result(item, 'present');
        return typeof isPresent === "undefined" ? true : isPresent;
      }),
      (item, index) => {
        const idFromTitle = !_.isUndefined(item.title) ? item.title.toLowerCase().replace(/\s/g, '_').replace(/<>"'/g, '') : (`item_${index}`);

        // allows 'disabled' to be a function that returns a message
        const disabled = _.result(item, 'disabled');

        return {
          role: this._normalizeRole(item.role),
          title: item.title,
          id: item.id || idFromTitle,
          href: item.href,
          action: item.action,
          data: this._normalizeDataAttribute(item.data),
          icon: item.icon,
          className: item.className || '',
          disabled: !_.isUndefined(disabled) ? disabled : false
        };
      }
    );
  }

  _normalizeRole(role) {
    switch (true) {
    case _.isUndefined(role):
    case role === 'item':
      return 'item';
    case role === 'separator':
    case role === 'header':
      return role;
    default:
      ExceptionHandling.logError(`Unrecognized Action Dropdown item role: ${role}`);
      return '';
    }
  }

  _normalizeDataAttribute(data) {
    const normalizedData = data || {};

    if (normalizedData.id || normalizedData.action) {
      ExceptionHandling.logError('Action Dropdown item data attribute option can not contain the following reserved attribute names: "id", "action"');
    }

    return normalizedData;
  }
}

_.extend(ActionDropdown.prototype, {
  tagName:        'div',
  template,
  defaultOptions: {
    id:              'dropdownMenu1',
    className:       'dropdown',
    buttonClassName: '',
    buttonType:      'default',
    title:           'Dropdown',
    items:           [],
    align:           'left',
    caret:           true
  }
});

export default ActionDropdown;
